import {
  ActiveFilterState,
  FilterGroup,
  HeaderConfig,
  Row,
} from 'components/Table/KhulaSupplierTable';
import {IFarmInputProduct} from 'constants/interfaces';
import React from 'react';
import {Box, IconButton, Tooltip} from '@material-ui/core';
import {_NumberWithSpaces} from 'constants/index';
import EditIcon from '@material-ui/icons/Edit';

export const inventoryTableHeaders = (
  depotPriceList?: boolean,
): HeaderConfig[] => [
  {
    field: 'idFormatted',
    title: 'Product',
    sortField: 'id',
    isSortable: true,
    isSearchable: true,
    isRightAligned: true,
  },
  {
    field: 'stockCode',
    title: 'Stock Code',
    isSortable: true,
    isSearchable: true,
    isRightAligned: false,
    hidden: true,
  },
  {
    field: 'name',
    title: 'Name',
    isSortable: true,
    isSearchable: true,
    isRightAligned: false,
  },
  {
    field: 'depotName',
    title: 'Depot',
    isSortable: true,
    sortField: 'depotName',
    isSearchable: true,
    searchField: 'depotName',
    isRightAligned: false,
  },
  ...(depotPriceList
    ? [
        {
          field: 'depotPriceFormatted',
          title: 'Price',
          isSortable: true,
          sortField: 'depotPrice',
          isSearchable: false,
          isRightAligned: true,
        },
      ]
    : []),
  {
    field: 'minOrderQuantity',
    title: 'MOQ',
    isSortable: true,
    sortField: 'minOrderQuantity',
    isSearchable: false,
    isRightAligned: true,
  },
  {
    field: 'stockOnHand',
    title: 'SOH',
    isSortable: true,
    sortField: 'stockOnHand',
    isSearchable: false,
    isRightAligned: true,
  },
  {
    field: 'minFreeShippingQuantity',
    title: 'Free Shipping QTY',
    isSortable: true,
    sortField: 'minFreeShippingQuantity',
    isSearchable: false,
    isRightAligned: true,
  },
  {
    field: 'actions',
    title: '',
    isSortable: false,
    isSearchable: false,
    isRightAligned: true,
  },
];

export const inventoryTableRows = (
  products: IFarmInputProduct[],
  onEdit: (product: IFarmInputProduct) => any,
): Row[] =>
  products.map((product) => {
    const actualId = product.id; // or string/number; ensure it matches Row's id type
    const idFormatted = product.depotInfo
      ? `${product.id}-${product.depotInfo.depotId}`
      : product.id;

    const depotName = product.depotInfo?.depot.name || '';
    const depotPrice = product.depotInfo?.price;
    const depotPriceFormatted = depotPrice
      ? 'R ' + _NumberWithSpaces(depotPrice)
      : '';
    const stockOnHand = product.depotInfo?.stockOnHand || '';
    const minOrderQuantity = product.depotInfo?.minOrderQuantity || '';
    const minFreeShippingQuantity =
      product.depotInfo?.minOrderQuantityFreeDelivery || '';

    return {
      // (1) Provide the actual "id" field for Row
      id: actualId, // must exist to satisfy Row interface
      // (2) Provide any extra fields for columns
      idFormatted,
      stockCode: product.stockCode ?? '',
      name: product.name ?? '',
      depotName,
      depotPrice, // numeric or undefined
      depotPriceFormatted,
      stockOnHand,
      minOrderQuantity,
      minFreeShippingQuantity,
      actions: <ProductRowIcons onEdit={() => onEdit(product)} />,
    };
  });

function ProductRowIcons(props: {onEdit: () => any}) {
  return (
    <Box display="flex" flexDirection="row">
      <Tooltip title="Edit product" aria-label="edit product">
        <IconButton
          aria-label="edit product"
          size="small"
          onClick={props.onEdit}
        >
          <EditIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}

const productsViewFilterGroup: FilterGroup = {
  name: 'View',
  filters: [
    {
      field: 'isInDepot',
      value: true,
      title: 'Inventory captured',
    },
    {
      field: 'isInDepot',
      value: false,
      title: 'Missing inventory',
    },
  ],
};

export const inventoryTableFilters = (args: {
  showProductsView: boolean;
}): FilterGroup[] => [
  ...(args.showProductsView ? [productsViewFilterGroup] : []),
];

export const getDefaultFilters = (): ActiveFilterState[] => {
  return [];
};
